<template>
    <zbScrollbar>
        <van-pull-refresh
            v-model="isVanLoading"
            :disabled="isDisabledRefresh"
            @refresh="storeReLoad"
            class="van-list-container"
        >
            <slot v-if="!isEmpty"></slot>
            <!-- 如果数据为空，并且不在加载状态 -->
            <div v-show="isEmpty" class="noMessage">
                <div class="bv bc message-content">
                    <div class="img"></div>
                    <div class="text">{{emptyMessage}}</div>
                </div>
            </div>
        </van-pull-refresh>
    </zbScrollbar>
</template>
<script>
import zbScrollbar from "@/components/scroll/Bar";
// 带下拉刷新的面板
export default {
    components: { zbScrollbar },
    props: {
        // 是否缓存页面信息
        // 为true时会缓存滚动条信息
        isKeep: {
            type: Boolean,
            default: false
        },
        // 无数据提示信息
        emptyMessage: {
            type: String,
            default: "暂无数据哦！"
        },
        // 是否禁用下拉刷新
        isDisabledRefresh: {
            type: Boolean
        },
        isEmpty: {
            type: Boolean
        }
    },
    data() {
        return {
            isVanLoading: false
        };
    },
    methods: {
        // 重载
        storeReLoad() {
            this.isVanLoading = false;
            // 抛出事件
            this.$emit("reLoad");
        }
    }
};
</script>